import { createFileRoute } from '@tanstack/react-router'
import { InvoiceList } from '@/features/billing/invoice-list/InvoiceList'
import { usePageTitle } from '@/hooks/usePageTitle'
import { z } from 'zod'

const invoiceSearchSchema = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
})

export const Route = createFileRoute('/_dashboard/clients/$clientId/invoices/')({
  component: RouteComponent,
  validateSearch: invoiceSearchSchema,
})

function RouteComponent() {
  usePageTitle('請求書一覧')
  return <InvoiceList />
}